import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {UiBuildInfo} from "../interfaces/rest/UiBuildInfo";
import {HttpRepository} from "./http.repository";
import {GlobalConfig} from "../configs/GlobalConfig";

@Injectable()
export class BuildInfoRepository {

  private readonly httpRepository = inject(HttpRepository);

  constructor() {
    // empty
  }

  getUiBuildInfo(): Observable<UiBuildInfo> {
    return this.httpRepository.get(`${GlobalConfig.endpoints.uiBuildInfo}`);
  }
}
